import React, {
  ChangeEvent,
  CSSProperties,
  useEffect,
  useId,
  useRef,
  useState,
} from 'react'

import { UseFormRegister } from 'react-hook-form/dist/types/form'

import cn from 'classnames'

import styles from './styles.module.scss'

interface IProps {
  style?: CSSProperties
  placeholder: string
  name: string
  register: UseFormRegister<any>
  readOnly?: boolean
  value?: string
  error?: boolean
  onClick?: () => void
  boxClassName?: string
}

//Resize
const ColorInput: React.FC<IProps> = ({
  style,
  placeholder,
  register,
  name,
  readOnly = false,
  value,
  error,
  onClick,
  boxClassName,
}) => {
  const [valueInput, setValueInput] = useState<string>('')
  const {
    onChange: onChangeRegister,
    onBlur,
    name: nameRegister,
    ref: refRegister,
  } = register(name)

  const id = useId()

  const inputRef = useRef<HTMLInputElement | null>(null)

  useEffect(() => {
    if (value) {
      const str = value
      setValueInput(str.charAt(0).toUpperCase() + str.slice(1))
    } else if (value === '') {
      setValueInput('')
    }
  }, [value])

  const onChange = (e: ChangeEvent<HTMLInputElement>) => {
    const { value } = e.target

    setValueInput(value)
  }

  return (
    <div className={cn(styles.inputBox, boxClassName)}>
      {React.createElement('input', {
        onClick: () => onClick && onClick(),
        readOnly: readOnly,
        value: valueInput,
        onChange: (e: any) => {
          onChangeRegister(e)
          onChange(e)
        },
        onBlur: onBlur,
        style: style,
        className: cn({
          [styles.input]: true,
          [styles.inputError]: error,
        }),
        type: 'color',
        placeholder: placeholder,
        ref: (e: any) => {
          refRegister(e)
          inputRef.current = e
        },
        name: name,
        id: id,
      })}

      <label htmlFor={id}>{placeholder}</label>
    </div>
  )
}

ColorInput.displayName = 'ColorInput'

export default ColorInput
